import { Box, Typography } from "@mui/material";
import React from "react";
export const Section = ({ children, title }) => (React.createElement(Box, { sx: { borderTop: "3px solid white", pt: 2 } },
    React.createElement(Typography, { sx: { pt: 0, textTransform: "uppercase" }, component: "h2", variant: "h4" }, title),
    children));
//# sourceMappingURL=section.js.map